<div class="cb-dialog" [ngClass]="'cb-dialog-from-'+alignment()" [attr.data-theme]="theme">
    <div [@backdropAnimation]="closing() ? 'closed' : 'opened'" class="cb-dialog-backdrop" (click)="backdropClick()">
    </div>
    <div role="dialog" [@dialogAnimation]="(closing())? 'closed' : 'opened'" #DialogWrapper class="cb-dialog-wrapper">
    </div>
</div>